// extracted by mini-css-extract-plugin
var _1 = "Tag-module__animateUploadProgressBarWidth--QnI39";
var _2 = "Tag-module__animatedBackground--eObNd";
var _3 = "Tag-module__content--vX1Pd";
var _4 = "Tag-module__wrapper--MzkNm";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "wrapper" }
